// Textile-based pricing system for Buzju Pillow Sets
// This file handles dynamic pricing based on textile type selection

// Configuration options
window.textilePricingConfig = {
  showPriceRange: false,  // Always show the selected variant's Shopify price
  animationDuration: 300, // Animation duration in milliseconds
  debugMode: true         // Enable/disable console logging
};

// Check if this is a product that should use textile pricing
window.shouldUseTextilePricing = function() {
  // Only apply textile pricing to Pillow Sets, not Pillow Covers
  
  // Method 1: Check product title
  const productTitle = document.querySelector('.product-title');
  if (productTitle) {
    const title = productTitle.textContent.trim().toLowerCase();
    const isPillowSet = title.includes('pillow set') || title.includes('pillow sets');
    const isPillowCover = title.includes('pillow cover') || title.includes('pillow covers');
    
    if (isPillowCover) {
      window.textileLog('🎨 Pillow Cover detected via title - textile pricing disabled', 'warn');
      return false;
    }
    
    if (isPillowSet) {
      window.textileLog('🎨 Pillow Set detected via title - textile pricing enabled', 'log');
      return true;
    }
  }
  
  // Method 2: Check breadcrumbs for additional context
  const breadcrumbs = document.querySelector('.module-breadcrumbs');
  if (breadcrumbs) {
    const breadcrumbText = breadcrumbs.textContent.toLowerCase();
    if (breadcrumbText.includes('pillow cover') || breadcrumbText.includes('pillow covers')) {
      window.textileLog('🎨 Pillow Cover detected via breadcrumbs - textile pricing disabled', 'warn');
      return false;
    }
    if (breadcrumbText.includes('pillow set') || breadcrumbText.includes('pillow sets')) {
      window.textileLog('🎨 Pillow Set detected via breadcrumbs - textile pricing enabled', 'log');
      return true;
    }
  }
  
  // Method 3: Check if this is a travel case product
  if (productTitle && productTitle.textContent.toLowerCase().includes('travel case')) {
    window.textileLog('🎨 Travel Case detected - textile pricing disabled', 'warn');
    return false;
  }
  
  // Default: don't use textile pricing for unknown products
  window.textileLog('🎨 Unknown product type - textile pricing disabled', 'warn');
  return false;
};

window.textilePricing = {
  "cotton-sateen": 16800, // $168.00 in cents
  "french-linen": 17900   // $179.00 in cents
};

// Helper function for conditional logging
window.textileLog = function(message, type = 'log') {
  if (window.textilePricingConfig.debugMode) {
    if (type === 'warn') {
      console.warn(message);
    } else if (type === 'error') {
      console.error(message);
    } else {
      console.log(message);
    }
  }
};

// Function to get price for display
// Always use Shopify's selected variant price to keep PDP, cart, and checkout in sync
window.getAdjustedPrice = function(variant) {
  if (!variant) {
    return 0;
  }
  window.textileLog(`🎨 Using Shopify variant price for display: $${(variant.price/100).toFixed(2)}`);
  return variant.price;
};

// Function to show initial price range
window.showInitialPriceRange = function() {
  const priceElement = document.querySelector('.product-price__final.money');
  if (!priceElement) return;
  
  // Check if textile pricing should be used for this product
  if (!window.shouldUseTextilePricing()) {
    window.textileLog('🎨 Textile pricing disabled - not showing price range');
    return;
  }
  
  const minPrice = Math.min(...Object.values(window.textilePricing)) / 100;
  const maxPrice = Math.max(...Object.values(window.textilePricing)) / 100;
  
  if (minPrice === maxPrice) {
    priceElement.textContent = `$${minPrice.toFixed(2)}`;
    priceElement.classList.remove('price-range');
    priceElement.classList.add('specific-price');
  } else {
    priceElement.textContent = `$${minPrice.toFixed(2)} - $${maxPrice.toFixed(2)}`;
    priceElement.style.fontSize = '0.9em'; // Slightly smaller for range display
    priceElement.classList.add('price-range');
    priceElement.classList.remove('specific-price');
  }
  
  window.textileLog(`🎨 Initial price range displayed: $${minPrice.toFixed(2)} - $${maxPrice.toFixed(2)}`);
};

// Alternative function: Show price based on initially selected variant
window.showInitialVariantPrice = function() {
  const priceElement = document.querySelector('.product-price__final.money');
  if (!priceElement) return;
  
  const variantSelect = document.querySelector('.product-select');
  if (!variantSelect || !window.productVariants) return;
  
  const variantId = variantSelect.value;
  const variant = window.productVariants[variantId];
  
  if (variant) {
    // For non-textile products, just show the original price
    if (!window.shouldUseTextilePricing()) {
      const priceInDollars = (variant.price / 100).toFixed(2);
      priceElement.textContent = `$${priceInDollars}`;
      priceElement.style.fontSize = '';
      priceElement.classList.remove('price-range');
      priceElement.classList.add('specific-price');
      window.textileLog(`🎨 Non-textile product - showing original price: $${priceInDollars} for ${variant.title}`);
      return;
    }
    
    const adjustedPrice = window.getAdjustedPrice(variant);
    const priceInDollars = (adjustedPrice / 100).toFixed(2);
    
    priceElement.textContent = `$${priceInDollars}`;
    priceElement.style.fontSize = '';
    priceElement.classList.remove('price-range');
    priceElement.classList.add('specific-price');
    
    window.textileLog(`🎨 Initial variant price displayed: $${priceInDollars} for ${variant.title}`);
  }
};

// Function to update displayed price based on textile selection
window.updateTextilePrice = function() {
  window.textileLog('🎨 updateTextilePrice() called - finding price element...');
  
  // Try multiple selectors to find the price element
  let priceElement = document.querySelector('.product-price__final.money') ||
                    document.querySelector('.product-price .money') ||
                    document.querySelector('.price .money') ||
                    document.querySelector('.price') ||
                    document.querySelector('[class*="price"]') ||
                    document.querySelector('[class*="money"]');
  
  if (!priceElement) {
    window.textileLog('🎨 Price element not found with any selector', 'warn');
    // Log all elements with price-related classes for debugging
    const allElements = document.querySelectorAll('*');
    const priceElements = Array.from(allElements).filter(el => 
      el.className && (el.className.includes('price') || el.className.includes('money'))
    );
    window.textileLog(`🎨 Found ${priceElements.length} elements with price-related classes:`, 'info');
    priceElements.forEach((el, i) => {
      window.textileLog(`🎨 Element ${i}: ${el.tagName}.${el.className} = "${el.textContent}"`, 'info');
    });
    return;
  }
  
  window.textileLog(`🎨 Found price element: ${priceElement.tagName}.${priceElement.className}`);
  
  const variantSelect = document.querySelector('.product-select');
  if (!variantSelect) {
    window.textileLog('🎨 Variant select not found', 'warn');
    return;
  }
  
  const variantId = variantSelect.value;
  window.textileLog(`🎨 Current variant ID: ${variantId}`);
  
  if (window.productVariants && window.productVariants[variantId]) {
    const variant = window.productVariants[variantId];
    window.textileLog(`🎨 Found variant: ${variant.title} with price: ${variant.price}`);
    
    // For non-textile products, just show the original price
    if (!window.shouldUseTextilePricing()) {
      const priceInDollars = (variant.price / 100).toFixed(2);
      priceElement.textContent = `$${priceInDollars}`;
      priceElement.style.fontSize = '';
      priceElement.classList.remove('price-range');
      priceElement.classList.add('specific-price');
      window.textileLog(`🎨 Non-textile product - price updated to: $${priceInDollars} for variant: ${variant.title}`);
      return;
    }
    
    const adjustedPrice = window.getAdjustedPrice(variant);
    const priceInDollars = (adjustedPrice / 100).toFixed(2);
    
    window.textileLog(`🎨 Adjusted price: ${adjustedPrice} -> $${priceInDollars}`);
    
    // Reset font size and update CSS classes for specific price display
    priceElement.style.fontSize = '';
    priceElement.classList.remove('price-range');
    priceElement.classList.add('specific-price');
    
    // Add visual feedback for price changes
    priceElement.style.transition = 'all 0.3s ease';
    priceElement.style.transform = 'scale(1.1)';
    priceElement.style.color = '#e74c3c';
    
    setTimeout(() => {
      priceElement.textContent = `$${priceInDollars}`;
      priceElement.style.transform = 'scale(1)';
      priceElement.style.color = '';
      window.textileLog(`🎨 Price element updated to: $${priceInDollars}`);

      // Update bundle pricing after the DOM has the latest price
      if (typeof window.updateBundlePricing === 'function') {
        window.updateBundlePricing();
      }
      if (typeof window.updateBundlePricingDisplay === 'function') {
        window.updateBundlePricingDisplay();
      }
    }, 150);
    
    window.textileLog(`🎨 Price updated to: $${priceInDollars} for variant: ${variant.title}`);
  } else {
    window.textileLog('🎨 Product variants data not available', 'warn');
  }
};

// Initialize textile pricing when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.textileLog('🎨 Textile pricing system initializing...');
  
  // Wait a bit for other scripts to load
  setTimeout(function() {
    if (window.productVariants) {
      // Show initial price based on configuration
      if (window.textilePricingConfig.showPriceRange) {
        window.showInitialPriceRange();
      } else {
        window.showInitialVariantPrice();
      }
      
      // Then update to specific price if variant is selected
      window.updateTextilePrice();
      
      // Listen for variant changes
      const variantSelect = document.querySelector('.product-select');
      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          window.updateTextilePrice();
          // Update bundle pricing immediately when variant changes
          if (typeof updateBundlePricing === 'function') {
            updateBundlePricing(); // Immediate update - no delay needed
          }
          // Also update our custom bundle pricing display
          window.updateBundlePricingDisplay();
        });
        window.textileLog('🎨 Textile pricing system initialized successfully');
      } else {
        window.textileLog('🎨 Variant select not found during initialization', 'warn');
      }
      
      // For non-textile products, ensure original price is displayed
      if (!window.shouldUseTextilePricing()) {
        setTimeout(window.restoreOriginalPrice, 200);
      }
    } else {
      window.textileLog('🎨 Product variants data not available during initialization', 'warn');
    }
  }, 1000);
});

// Also listen for variant changes on swatch clicks
document.addEventListener('click', function(e) {
  if (e.target.closest('.swatch-label')) {
    window.textileLog('🎨 Swatch clicked, updating price...');
    
    // Check if this is a fabric/textile swatch
    const swatchContainer = e.target.closest('.swatch-container');
    if (swatchContainer) {
      const label = swatchContainer.previousElementSibling;
      if (label && (label.textContent.includes('Cover Material') || label.textContent.includes('Textile') || label.textContent.includes('Fabric'))) {
        window.textileLog('🎨 Fabric/Textile swatch clicked - updating price immediately...');
        // Update price immediately for fabric/textile changes
        setTimeout(function() {
          window.updateTextilePrice();
          // Update bundle pricing immediately when swatch changes
          if (typeof updateBundlePricing === 'function') {
            updateBundlePricing(); // Immediate update - no delay needed
          }
          // Also update our custom bundle pricing display
          if (typeof window.updateBundlePricingDisplay === 'function') {
            window.updateBundlePricingDisplay();
          }
        }, 50); // Faster update for fabric changes
        return;
      }
    }
    
    // For other swatches, wait a bit longer for the variant to change
    setTimeout(function() {
      window.updateTextilePrice();
      // Update bundle pricing immediately when swatch changes
      if (typeof updateBundlePricing === 'function') {
        updateBundlePricing(); // Immediate update - no delay needed
      }
      // Also update our custom bundle pricing display
      if (typeof window.updateBundlePricingDisplay === 'function') {
        window.updateBundlePricingDisplay();
      }
    }, 100);
  }
});

// Function to immediately update bundle pricing display on the product page
window.updateBundlePricingDisplay = function() {
  window.textileLog('🎒 Updating bundle pricing display immediately...');
  
  // Find the bundle pricing display elements on the page
  const bundleSavingsElement = document.querySelector('.bundle-savings .savings-amount');
  const bundleTotalElement = document.querySelector('.bundle-total .total-price');
  
  if (!bundleSavingsElement || !bundleTotalElement) {
    window.textileLog('🎒 Bundle pricing display elements not found', 'warn');
    return;
  }
  
  // Get the current variant price directly from Shopify data
  let currentVariantPrice = null;
  const variantSelect = document.querySelector('.product-select');
  if (variantSelect && variantSelect.value && window.productVariants) {
    const variantData = window.productVariants[variantSelect.value];
    if (variantData) {
      currentVariantPrice = variantData.price / 100;
    }
  }
  
  if (currentVariantPrice === null) {
    const currentPriceElement = document.querySelector('.product-price__final.money');
    if (currentPriceElement) {
      const priceText = currentPriceElement.textContent;
      const priceMatch = priceText.match(/\$(\d+(?:\.\d{2})?)/);
      if (priceMatch) {
        currentVariantPrice = parseFloat(priceMatch[1]);
      }
    }
  }
  
  if (currentVariantPrice === null) {
    window.textileLog('🎒 Unable to determine current variant price for bundle display', 'warn');
    return;
  }
  
  window.textileLog(`🎒 Current variant price: $${currentVariantPrice}`);
  
  // Get the selected travel case (if any)
  const selectedTravelCase = document.querySelector('input[name="travel_case_bundle"]:checked, input[name="travel_case"]:checked');
  if (!selectedTravelCase || selectedTravelCase.value === 'none') {
    window.textileLog('🎒 No travel case selected, hiding bundle pricing');
    // Hide bundle pricing if no travel case is selected
    const bundlePricingContainer = document.querySelector('.bundle-pricing');
    if (bundlePricingContainer) {
      bundlePricingContainer.style.display = 'none';
    }
    return;
  }
  
  // Determine bundle pricing entry for the selected travel case
  let travelCasePrice = null;
  let discountAmount = null;
  let pricingEntry = null;
  if (window.bundlePricingData && window.bundlePricingData[selectedTravelCase.value]) {
    pricingEntry = window.bundlePricingData[selectedTravelCase.value];
    if (pricingEntry && typeof pricingEntry.price === 'number' && !isNaN(pricingEntry.price)) {
      travelCasePrice = pricingEntry.price;
    }
    if (pricingEntry && typeof pricingEntry.discount_amount === 'number' && !isNaN(pricingEntry.discount_amount)) {
      discountAmount = Math.max(pricingEntry.discount_amount, 0);
    }
  }

  // Fallback to DOM price if metafield data missing
  if (travelCasePrice === null) {
    const travelCasePriceElement = document.querySelector('.travel-case-price, [data-travel-case-price]');
    if (travelCasePriceElement) {
      const travelCasePriceText = travelCasePriceElement.textContent;
      const travelCasePriceMatch = travelCasePriceText.match(/\$(\d+(?:\.\d{2})?)/);
      if (travelCasePriceMatch) {
        travelCasePrice = parseFloat(travelCasePriceMatch[1]);
      }
    }
  }

  if (travelCasePrice === null || isNaN(travelCasePrice)) {
    travelCasePrice = 54; // Default fallback
  }
  
  const computeDiscountAmount = () => {
    if (!pricingEntry) {
      return 0;
    }
    const { discount_amount, discount_percent, discount_basis } = pricingEntry;

    if (typeof discount_amount === 'number' && !isNaN(discount_amount)) {
      return Math.max(discount_amount, 0);
    }

    if (typeof discount_percent === 'number' && !isNaN(discount_percent)) {
      const basis = discount_basis === 'total'
        ? totalWithoutDiscount
        : travelCasePrice;
      return Math.max(basis * (discount_percent / 100), 0);
    }

    return 0;
  };
  
  const totalWithoutDiscount = currentVariantPrice + travelCasePrice;
  const appliedDiscount = discountAmount !== null ? discountAmount : computeDiscountAmount();
  const totalWithDiscount = Math.max(totalWithoutDiscount - appliedDiscount, 0);

  window.textileLog(`🎒 Travel case price: $${travelCasePrice}`);
  window.textileLog(`🎒 Bundle discount amount: $${appliedDiscount}`);
  
  // Update the bundle pricing display
  bundleSavingsElement.textContent = `-$${appliedDiscount.toFixed(2)}`;
  bundleTotalElement.textContent = `$${totalWithDiscount.toFixed(2)}`;
  
  // Show the bundle pricing
  const bundlePricingContainer = document.querySelector('.bundle-pricing');
  if (bundlePricingContainer) {
    bundlePricingContainer.style.display = 'block';
  }
  
  window.textileLog(`🎒 Bundle pricing updated: Pillow $${currentVariantPrice} + Travel Case $${travelCasePrice} = $${totalWithoutDiscount}, $${appliedDiscount.toFixed(2)} off = $${totalWithDiscount.toFixed(2)}`);
  
  // Add visual feedback for the update
  bundleTotalElement.style.transition = 'all 0.3s ease';
  bundleTotalElement.style.transform = 'scale(1.1)';
  bundleTotalElement.style.color = '#e74c3c';
  
  setTimeout(() => {
    bundleTotalElement.style.transform = 'scale(1)';
    bundleTotalElement.style.color = '';
  }, 300);
};

// Function to restore original price for non-textile products
window.restoreOriginalPrice = function() {
  if (!window.shouldUseTextilePricing()) {
    const priceElement = document.querySelector('.product-price__final.money');
    if (priceElement && window.productVariants) {
      const variantSelect = document.querySelector('.product-select');
      if (variantSelect) {
        const variantId = variantSelect.value;
        const variant = window.productVariants[variantId];
        if (variant) {
          const originalPrice = (variant.price / 100).toFixed(2);
          priceElement.textContent = `$${originalPrice}`;
          priceElement.style.fontSize = '';
          priceElement.classList.remove('price-range');
          priceElement.classList.add('specific-price');
          window.textileLog(`🎨 Restored original price: $${originalPrice} for ${variant.title}`);
        }
      }
    }
  }
};

// Listen for URL changes (for single page apps)
let currentUrl = location.href;
new MutationObserver(() => {
  const url = location.href;
  if (url !== currentUrl) {
    currentUrl = url;
    window.textileLog('🎨 URL changed, updating textile pricing...');
    setTimeout(() => {
      if (window.shouldUseTextilePricing()) {
        if (window.textilePricingConfig.showPriceRange) {
          window.showInitialPriceRange();
        } else {
          window.showInitialVariantPrice();
        }
        window.updateTextilePrice();
      } else {
        // For non-textile products, restore original price
        window.restoreOriginalPrice();
      }
      
      // Update bundle pricing immediately after URL changes
      if (typeof updateBundlePricing === 'function') {
        updateBundlePricing(); // Immediate update - no delay needed
      }
    }, 500);
  }
}).observe(document, {subtree: true, childList: true});

// Add direct event listeners for fabric/textile swatches to ensure price updates
document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit for the page to fully load
  setTimeout(function() {
    window.textileLog('🎨 Setting up direct fabric swatch listeners...');
    
    // Find all fabric/textile swatch containers
    const allSwatchContainers = document.querySelectorAll('.swatch-container');
    allSwatchContainers.forEach(container => {
      const label = container.previousElementSibling;
      if (label && (label.textContent.includes('Cover Material') || label.textContent.includes('Textile') || label.textContent.includes('Fabric'))) {
        window.textileLog(`🎨 Found fabric container: ${label.textContent}`);
        
        // Add event listeners to all radio buttons in this container
        const radioButtons = container.querySelectorAll('input[type="radio"]');
        radioButtons.forEach(radio => {
          radio.addEventListener('change', function() {
            window.textileLog(`🎨 Fabric radio changed to: ${this.value} - updating price immediately...`);
            
            // Update price immediately
            setTimeout(() => {
              window.updateTextilePrice();
            }, 50);
          });
        });
      }
    });
  }, 1000);
});
